import { Icon, IconButton } from '@smartgift/frontend-toolkit';
import React from 'react';
import styled from 'styled-components';

const MemberItemWrapper = styled.div`
  position: relative;

  &:not(:last-child) {
    margin-bottom: 16px;
    margin-right: 16px;
  }
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  right: -8px;
  top: -8px;
`;

const MemberNameWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-gray-200);
  border-radius: var(--size-border-radius-md);
  display: flex;
  height: 56px;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;
`;

const Name = styled.div`
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: capitalize;
  white-space: nowrap;
`;

const NameIcon = styled.div`
  align-items: center;
  background-color: var(--color-warning-weaker);
  border: 1px solid var(--color-warning-weak);
  border-radius: var(--size-border-radius-circle);
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: 8px;
  text-transform: uppercase;
  width: 32px;
`;

export default function MemberItem({ firstName, onRemove }) {
  return (
    <MemberItemWrapper>
      <CloseButton onClick={onRemove} color="neutral" variant="contained">
        <Icon name="close" />
      </CloseButton>
      <MemberNameWrapper>
        <NameIcon>{firstName.charAt(0)}</NameIcon>
        <Name>{firstName}</Name>
      </MemberNameWrapper>
    </MemberItemWrapper>
  );
}
